// Shared date utilities — always use these instead of new Date() for date handling
// to avoid UTC vs Eastern timezone mismatches.

// Returns today's date as YYYY-MM-DD in Eastern time.
// Use this anywhere you need "today" for a date input or comparison.
export function todayEastern() {
  return new Date().toLocaleDateString('en-CA', { timeZone: 'America/New_York' });
}

// Formats a stored date value (YYYY-MM-DD or ISO timestamp) as MM/DD/YYYY
// without any timezone conversion — safe for DATE columns from PostgreSQL.
export function formatDate(rawDate) {
  if (!rawDate) return '';
  const datePart = String(rawDate).split('T')[0];
  const [y, m, d] = datePart.split('-').map(Number);
  if (!y || !m || !d) return String(rawDate);
  return `${String(m).padStart(2, '0')}/${String(d).padStart(2, '0')}/${y}`;
}

// Formats a stored date value as a long human-readable string (e.g. "May 31, 2026")
// without timezone conversion.
export function formatDateLong(rawDate) {
  if (!rawDate) return '';
  const datePart = String(rawDate).split('T')[0];
  const [y, m, d] = datePart.split('-').map(Number);
  if (!y || !m || !d) return String(rawDate);
  return new Date(y, m - 1, d).toLocaleDateString('en-US', {
    year: 'numeric', month: 'long', day: 'numeric'
  });
}
